export default {
  namespaced: true,
  state: {
    homeRoutes: ['', 'signIn', 'signUp', 'accommodation'],
    adminRoutes: ['admin'],
  },
};
